import type { Dictionary } from '../i18n';
import { ApiError } from './api-core';

const num = (v: unknown): number | null => (typeof v === 'number' && Number.isFinite(v) ? v : null);

/** The text a person reads for a failed request; numbers come from the API's details. */
export function errorText(err: unknown, t: Dictionary): string {
  if (!(err instanceof ApiError)) return t.common.failed;
  const e = t.errors;
  const d = err.details;
  switch (err.code) {
    case 'NETWORK':
      return e.network;
    case 'DAILY_LIMIT': {
      const limit = num(d.limit);
      return limit === null ? t.common.failed : e.dailyLimit(limit);
    }
    case 'NO_CREDITS':
      return e.noCredits;
    case 'KIND_UNAVAILABLE':
      return t.ideas.kindUnavailable;
    case 'NO_MORE_IDEAS':
      return t.ideas.noMore;
    case 'TOO_SHORT': {
      const min = num(d.minChars);
      return min === null ? t.common.failed : e.tooShort(min);
    }
    case 'TOO_LONG': {
      // A recording carries maxSeconds, a typed thought maxChars.
      const seconds = num(d.maxSeconds);
      if (seconds !== null) return e.tooLong(seconds);
      const chars = num(d.maxChars);
      return chars === null ? t.common.failed : e.tooLongText(chars);
    }
    case 'TOO_BIG':
      return e.tooBig;
    case 'UNSUPPORTED_FORMAT':
      return e.unsupportedFormat;
    case 'BUSY':
      return e.busy;
    case 'VERSION_CONFLICT':
      return e.versionConflict;
    case 'FORM_ISSUES':
      return e.formIssues;
    case 'EMPTY_AUDIO':
      return e.emptyAudio;
    case 'NOTHING_TO_UNDO':
      return e.nothingToUndo;
    case 'NOT_FOUND':
      return e.notFound;
    case 'PROVIDER_UNAVAILABLE':
      return e.providerUnavailable;
    case 'EMPTY_BLOCKS':
      return e.emptyBlocks;
    case 'BAD_PROMPTS':
      return e.badPrompts;
    case 'NO_ITEMS':
      return e.noItems;
    case 'INVALID_QUERY':
      return e.invalidQuery;
    case 'USE_REWRITE':
      return e.useRewrite;
    case 'REWRITE_LIMIT':
      return t.formatText.rewriteLimit;
    case 'SAME_KIND':
      return e.sameKind;
    case 'STYLE_UNKNOWN':
      return e.styleUnknown;
    default:
      return t.common.failed;
  }
}
